import type { UnitLegacy } from '@netpurpose/types'
import type { AxiosInstances } from '../../client'
import { SimpleAbstractModelApi } from '../SimpleAbstractModelApi'
import { formatUnit, reverseUnitFieldMap } from './formatUnit'
import { type BackendUnit, parseUnit } from './parseUnit'

export default class UnitApi extends SimpleAbstractModelApi<BackendUnit, UnitLegacy> {
  endpoint = '/units'
  modelFormatter = formatUnit
  reverseFieldMap = reverseUnitFieldMap

  constructor(axiosInstances: AxiosInstances) {
    super(axiosInstances, parseUnit)
  }
}
